import { render, staticRenderFns } from "./RegistrationQuestionForm.vue?vue&type=template&id=f943844e&scoped=true"
import script from "./RegistrationQuestionForm.vue?vue&type=script&lang=js"
export * from "./RegistrationQuestionForm.vue?vue&type=script&lang=js"
import style0 from "./RegistrationQuestionForm.vue?vue&type=style&index=0&id=f943844e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f943844e",
  null
  
)

export default component.exports